$(document).ready(function(e){

	if ($(document).find('.field.id-expiry')){
		$(document).find('.field.id-expiry').each(function(){

            var dom = $(this);
            var minYear = new Date().getFullYear()
            var maxYear = new Date().getFullYear()+20;

			// initiate and configure date dropdowns plugin
			// https://www.jqueryscript.net/time-clock/Easy-Customizable-jQuery-Dropdown-Date-Picker-Plugin.html
			var input = dom.find('input').dateDropdowns({
				defaultDateFormat: "dd/mm/yy",
				submitFormat: "dd/mm/yyyy",
				monthFormat: "short",
				daySuffixes: false,
				minYear: minYear,
				maxYear: maxYear
			});			

			PopulateDropdownsOnLoad(input,dom);

		});

		function PopulateDropdownsOnLoad(input,wrapper){
			if(input.val()){
				var inputDate_parts = input.val().split("/");
				var dropdowns = wrapper.find('select');
				dropdowns.each(function(){
					if($(this).is('.day')){
						$(this).val(inputDate_parts[0]);
					}
					if($(this).is('.month')){
						$(this).val(inputDate_parts[1]);
					}
					if($(this).is('.year')){
						$(this).val(inputDate_parts[2]);
					}
				});
			}
		}

	}	

	if($(document).find('input[name="ID_Docs_OtherOptions"]')){
		$(document).find('input[name="ID_Docs_OtherOptions"]').each(function(){
			if($(this).parents('.optionset').data('dependents')){
				var dependents = $(this).parents('.optionset').data('dependents').split(',');
				var wrapper = $(this).parents('.togglable-fields');

				$(this).rules(
					"add", {
						required: function(element) {
							var fail = true;
							// return true if the field has FAILED validation checks
							// return false if the field has PASSED validation checks
							// Man that's confusing as. But anyway...
							// In this case we need inputted value for the fields listed in data-dependents
							// (#Form_Form_PassportNumber or #Form_Form_DriversLicence or both)
							$.each(dependents, function(index, value) {
								if($(document).find('input[name="' + value + '"]')){									
									// If the fields have no values, fail the validation (we need to show the other option)
									if($(document).find('input[name="' + value + '"]').val() != ''){										
										fail = false;
									}
								}
							});

							if(fail){
								// if validation has failed for "real" ID fields,
								// show list of other options
								// (check for error msg first to avoid showing on first load)
								if(wrapper.find('div.error').length){
									wrapper.removeClass('hide');
									window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
								}
							}else{
								wrapper.addClass('hide');
							}

							return fail;
						},
						messages: {						
							required: 'You must select an ID verification method to proceed'
						}
					}
				);
			}
		});	
	}
	
});